import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import "./styles/global.css";
import "./styles/h5-element-ui.css";
import { hydratePermissionCodesFromStorage, hasPermission } from "./utils/permissionStore";

Vue.config.productionTip = false;
Vue.use(ElementUI, {
  size: "mini"
});

hydratePermissionCodesFromStorage();
Vue.prototype.$can = (code) => hasPermission(code);

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
